import { Link } from 'react-router-dom';
import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';

export default function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 w-full z-50 pt-safe bg-white border-b border-[#d4a10d]/20">
      <div className="max-w-7xl mx-auto flex justify-between items-center h-16 sm:h-20 px-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-2 sm:gap-3 min-h-[48px]" aria-label="Point Break Systems - Home">
          <img
            src="/media/header-logo.webp"
            width={44}
            height={44}
            decoding="async"
            alt=""
            className="w-9 h-9 sm:w-10 sm:h-10 lg:w-11 lg:h-11 rounded-lg object-cover border-2 border-[#d4a10d]/30"
          />
          <span className="flex flex-col text-black">
            <span className="brand-title text-base sm:text-lg lg:text-xl font-bold leading-tight">POINT BREAK</span>
            <span className="brand-title text-xs sm:text-sm font-semibold leading-tight">SYSTEMS</span>
          </span>
        </Link>
        <DesktopNav />
        <MobileNav />
      </div>
    </header>
  );
}
